<div class="container p-4 bg-whitesmoke">
  <app-breadcrumb></app-breadcrumb>
  
  <!-- Combined Header Row - Modern Design -->
  <div class="d-flex align-items-center gap-3 mb-4 flex-wrap">
    <!-- Left: Active Cards Info and Action Button -->
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted small">
        Active Cards: <strong class="text-dark">{{ getUsedLicenses() }} of {{ currentUser?.license || 0 }}</strong>
        <small class="ms-2 text-success" *ngIf="!isLicenseLimitReached">Remaining: {{ remainingLicenses }}</small>
        <small class="ms-2 text-danger" *ngIf="isLicenseLimitReached">Limit reached</small>
      </span>
      
      <!-- Pay Now Button - Show when limit reached -->
      <button 
        mat-raised-button 
        color="warn" 
        *ngIf="isLicenseLimitReached" 
        (click)="goToUpgradeLicense()"
        class="px-3 rounded-pill">
        <mat-icon class="me-1" style="font-size: 18px;">payment</mat-icon>
        Pay Now
        <span class="ms-2">({{ remainingLicenses }} remaining)</span>
      </button>

        <!-- Always visible Create vCard button -->
        <button 
          mat-raised-button 
          color="accent" 
          class="px-3 rounded-pill ms-2"
          (click)="openCreateForm()">
          <mat-icon class="me-1" style="font-size: 18px;">add</mat-icon>
          Create vCard
        </button>
    </div>
    
    <!-- Center: Search Bar (Desktop) -->
    <div class="flex-grow-1 mx-3 d-none d-md-block">
      <div class="search-container">
        <mat-icon class="search-icon">search</mat-icon>
        <input 
          type="text"
          class="form-control rounded-pill search-input"
          placeholder="Search cards..." 
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()">
      </div>
    </div>
    
    <!-- Right: View Toggle (Desktop with text, Mobile icons only) -->
    <div class="d-flex align-items-center gap-2 ms-auto">
      <!-- Desktop View Toggle -->
      <div class="btn-group view-toggle-group rounded-pill overflow-hidden d-none d-md-flex" role="group">
        <button 
          type="button"
          class="btn btn-sm px-3"
          [ngClass]="viewMode === 'grid' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'grid'"
          matTooltip="Grid View">
          <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'grid' ? 'check_circle' : 'grid_view' }}
          </mat-icon>
          <span>Grid View</span>
        </button>
        <button 
          type="button"
          class="btn btn-sm px-3"
          [ngClass]="viewMode === 'list' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'list'"
          matTooltip="List View">
          <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'list' ? 'check_circle' : 'view_list' }}
          </mat-icon>
          <span>List View</span>
        </button>
      </div>
      
      <!-- Mobile View Toggle (Icons only) -->
      <div class="btn-group view-toggle-group rounded-pill overflow-hidden d-flex d-md-none" role="group">
        <button 
          type="button"
          class="btn btn-sm px-2"
          [ngClass]="viewMode === 'grid' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'grid'"
          matTooltip="Grid View">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'grid' ? 'check_circle' : 'grid_view' }}
          </mat-icon>
        </button>
        <button 
          type="button"
          class="btn btn-sm px-2"
          [ngClass]="viewMode === 'list' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'list'"
          matTooltip="List View">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'list' ? 'check_circle' : 'view_list' }}
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  
  <!-- Search Bar (Mobile) -->
  <div class="mb-4 d-block d-md-none">
    <div class="search-container">
      <mat-icon class="search-icon">search</mat-icon>
      <input 
        type="text"
        class="form-control rounded-pill search-input"
        placeholder="Search cards..." 
        [(ngModel)]="searchTerm"
        (input)="onSearchChange()">
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading()" class="text-center py-5">
    <mat-spinner diameter="50" class="mx-auto"></mat-spinner>
    <p class="mt-3 text-muted">Loading your vCards...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error() && !loading()" class="alert alert-danger">
    <div class="d-flex align-items-center">
      <mat-icon class="me-2">error</mat-icon>
      <div class="flex-grow-1">
        <h6 class="mb-1">Error Loading vCards</h6>
        <p class="mb-0">{{ error() }}</p>
      </div>
      <button mat-button (click)="loadCards()">
        <mat-icon>refresh</mat-icon>
        Retry
      </button>
    </div>
  </div>

  <!-- No Cards State -->
  <div *ngIf="!loading() && !error() && cards().length === 0" class="text-center py-5">
    <mat-icon style="font-size: 64px; width: 64px; height: 64px;" class="text-muted">credit_card</mat-icon>
    <h4 class="mt-3">No vCards Found</h4>
    <p class="text-muted">Create your first digital business card to get started</p>
    <button mat-raised-button color="primary" (click)="openCreateForm()" class="mt-2">
      <mat-icon class="me-2">add</mat-icon>
      Create Your First vCard
    </button>
  </div>

  <!-- Grid View -->
  <div *ngIf="!loading() && !error() && cards().length > 0 && viewMode === 'grid'" class="row g-4">
    <div class="col-12 col-md-6 col-lg-4" *ngFor="let card of filteredCards">
      <div class="business-card-wrapper">
        <div 
          class="business-card" 
          (click)="viewCard(card)"
          #cardElement
          [ngStyle]="{
            'background': card.primary_color_1 && card.primary_color_2 
              ? 'linear-gradient(135deg,' + card.primary_color_1 + ',' + card.primary_color_2 + ')'
              : 'linear-gradient(135deg,#ffffff,#f8f9fa)',
            'color': getSmartTextColor(card.primary_color_1 || '#ffffff', card.primary_color_2 || '#f8f9fa')
          }">
          <!-- Status Badge -->
          <div class="card-status-overlay-top">
            <span
              class="status-badge"
              [ngClass]="card.isVerified ? 'verified' : 'not-verified'">
              {{ card.isVerified ? 'Verified' : 'Not Verified' }}
            </span>
          </div>

          <!-- Vertical Action Buttons -->
          <div class="card-actions-overlay-vertical" (click)="$event.stopPropagation()">
            <button mat-icon-button class="action-btn" (click)="navigateToHandlerLink(card); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button class="action-btn" (click)="editCard(card); $event.stopPropagation()" >
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="action-btn flip-btn" (click)="flipCard(cardElement); $event.stopPropagation()">
              <mat-icon>flip</mat-icon>
            </button>
          </div>

          <!-- Card Inner (Flip Container) -->
          <div class="card-inner">
            <!-- Front Side -->
            <div class="card-front">
              <div class="card-header">
                <div class="company-logo">
                  <img *ngIf="card.business_info?.companyLogo" [src]="card.business_info?.companyLogo" alt="Company Logo" />
                  <div *ngIf="!card.business_info?.companyLogo" class="logo-placeholder">
                    <mat-icon>business</mat-icon>
                  </div>
                </div>
                <div class="contact-name">
                  <h3>{{ card.contact_info?.contactName }}</h3>
                  <p class="designation">{{ card.contact_info?.jobTitle || card.contact_info?.department }}</p>
                  <p class="designation">{{ card.business_info?.businessName }}</p>
                </div>
              </div>

              <mat-divider></mat-divider>

              <div class="card-contact-details">
                <div *ngIf="card.contact_info?.primaryEmail" class="detail-item">
                  <mat-icon>email</mat-icon>
                  <span>{{ card.contact_info?.primaryEmail }}</span>
                </div>
                <div *ngIf="card.contact_info?.primaryPhone" class="detail-item">
                  <mat-icon>phone</mat-icon>
                  <span>{{ card.contact_info?.primaryPhone }}</span>
                </div>
                <div *ngIf="card.contact_info?.whatsappNumber" class="detail-item">
                  <mat-icon>chat</mat-icon>
                  <span>{{ card.contact_info?.whatsappNumber }}</span>
                </div>
              </div>
            </div>

            <!-- Back Side -->
            <div class="card-back">
              <h4>{{ card.business_info?.businessName }}</h4>
              <mat-divider></mat-divider>

              <div *ngIf="card.business_info?.companyAddress" class="detail-item">
                <mat-icon>location_on</mat-icon>
                <span>{{ card.business_info?.companyAddress }}</span>
              </div>
              <div *ngIf="card.business_info?.companyEmail" class="detail-item">
                <mat-icon>email</mat-icon>
                <span>{{ card.business_info?.companyEmail }}</span>
              </div>
              <div *ngIf="card.business_info?.companyWebsite" class="detail-item">
                <mat-icon>language</mat-icon>
                <span>{{ card.business_info?.companyWebsite }}</span>
              </div>

              <div *ngIf="card.social_links && card.social_links.length > 0" class="social-links">
  
  <span class="fw-semibold mt-2 mb-1">Follow Us</span>
   <div class="detail-item">
  <mat-icon>share</mat-icon>
    <a [href]="card.social_links[0].url" target="_blank" (click)="$event.stopPropagation()">
      {{ card.social_links[0].platform }}
    </a>
  </div>
</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- List View -->
  <div *ngIf="!loading() && !error() && cards().length > 0 && viewMode === 'list'" class="list-view">
    <mat-card class="mb-3 position-relative" *ngFor="let card of filteredCards" (click)="viewCard(card)">
      <mat-card-content class="p-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center flex-grow-1">
            <div class="me-3">
              <div class="rounded-circle bg-light d-flex align-items-center justify-content-center" 
                   style="width: 48px; height: 48px;">
                <mat-icon>person</mat-icon>
              </div>
            </div>
            <div class="flex-grow-1">
              <h6 class="mb-1 fw-bold">{{ card.contact_info?.contactName }}</h6>
              <p class="mb-1 text-muted small">{{ card.business_info?.businessName }}</p>
              <div class="d-flex gap-3 small text-muted">
                <span *ngIf="card.contact_info?.primaryEmail">
                  <mat-icon class="align-middle" style="font-size: 16px;">email</mat-icon>
                  {{ card.contact_info?.primaryEmail }}
                </span>
                <span *ngIf="card.contact_info?.primaryPhone">
                  <mat-icon class="align-middle" style="font-size: 16px;">phone</mat-icon>
                  {{ card.contact_info?.primaryPhone }}
                </span>
              </div>
            </div>
          </div>
          
          <div class="d-flex align-items-center gap-2">
            <span 
              class="badge"
              [ngClass]="card.isVerified ? 'bg-success' : 'bg-danger'">
              {{ card.isVerified ? 'Verified' : 'Not Verified' }}
            </span>
            
            <!-- Vertical Action Buttons -->
            <div class="d-flex flex-column gap-1">
              <button mat-icon-button class="p-1" style="width: 32px; height: 32px;" (click)="navigateToHandlerLink(card)" matTooltip="View Card">
                <mat-icon style="font-size: 20px;">visibility</mat-icon>
              </button>
              <button mat-icon-button class="p-1" style="width: 32px; height: 32px;" (click)="editCard(card)" matTooltip="Edit Card">
                <mat-icon style="font-size: 20px;">edit</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Create/Edit Form Modal -->
<div *ngIf="showCreateForm" class="modal-overlay" (click)="onOverlayClick($event)">
  <div (click)="$event.stopPropagation()" class="modal-dialog" style="max-width: 800px;">
    <mat-card>
      <mat-card-header class="border-bottom pb-3">
        <mat-card-title class="d-flex align-items-center justify-content-between w-100">
          <span>
            <mat-icon class="me-2 align-middle">{{ isEditing ? 'edit' : 'add_circle' }}</mat-icon>
            {{ isEditing ? 'Edit vCard' : 'Create vCard' }}
          </span>
          <button mat-icon-button (click)="closeCreateForm()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-card-title>
      </mat-card-header>
      
      <mat-card-content class="p-4">
        <div *ngIf="createError" class="alert alert-danger mb-3">
          <strong>{{ createError.title || 'Error' }}</strong>
          <p class="mb-0">{{ createError.message }}</p>
        </div>
        
        <form (ngSubmit)="createCard()" #createForm="ngForm">
          <div class="row">
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">
                <mat-icon class="me-2 align-middle">person</mat-icon> Contact Information
              </h6>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Business Name</mat-label>
                <input matInput [(ngModel)]="newCardForm.businessName" name="businessName">
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Full Name</mat-label>
                <input matInput [(ngModel)]="newCardForm.name" name="name" required>
                <mat-icon matSuffix>person</mat-icon>
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Email</mat-label>
                <input matInput type="email" [(ngModel)]="newCardForm.email" name="email" required>
                <mat-icon matSuffix>email</mat-icon>
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Phone</mat-label>
                <input matInput [(ngModel)]="newCardForm.phone" name="phone" required>
                <mat-icon matSuffix>phone</mat-icon>
              </mat-form-field>
            </div>
            
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">
                <mat-icon class="me-2 align-middle">credit_card</mat-icon> Card Information
              </h6>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Card Type</mat-label>
                <mat-select [(value)]="newCardForm.type" panelClass="overlay-panel">
                  <mat-option *ngFor="let option of cardTypeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-icon matSuffix>business_center</mat-icon>
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Industry</mat-label>
                <mat-select [(value)]="newCardForm.industry" panelClass="overlay-panel">
                  <mat-option *ngFor="let option of industryOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-icon matSuffix>domain</mat-icon>
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Handler/Username</mat-label>
                <input matInput [(ngModel)]="newCardForm.handler" name="handler" 
                       [disabled]="isEditing" pattern="^[a-zA-Z0-9_-]{3,30}$" required>
                <mat-icon matSuffix>alternate_email</mat-icon>
                <mat-hint>3-30 characters</mat-hint>
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Language</mat-label>
                <mat-select [(value)]="newCardForm.language" panelClass="overlay-panel">
                  <mat-option *ngFor="let option of languageOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-icon matSuffix>language</mat-icon>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card-content>
      
      <mat-card-actions class="border-top p-3 d-flex justify-content-end gap-2">
        <button mat-button (click)="closeCreateForm()">Cancel</button>
        <button mat-raised-button color="primary" (click)="createCard()" [disabled]="creating">
          <mat-spinner *ngIf="creating" diameter="20" class="me-2"></mat-spinner>
          <mat-icon *ngIf="!creating" class="me-2">{{ isEditing ? 'save' : 'add' }}</mat-icon>
          {{ creating ? "Processing..." : isEditing ? "Save Changes" : "Create vCard" }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
<!-- License Limit Popup -->
<div *ngIf="showLicensePopup" class="modal-overlay" (click)="closeLicensePopup()">
  <div class="modal-dialog p-4" (click)="$event.stopPropagation()" style="max-width: 400px; background: #fff; border-radius: 8px;">
    <h4 class="mb-3 text-center">
      <mat-icon style="font-size: 48px; color: #f44336;">warning</mat-icon>
      <br>
      License Limit Reached
    </h4>
    <p class="text-center mb-4">
      You have reached your license limit. Upgrade your plan to create more cards.
    </p>

    <div class="d-flex justify-content-between">
      <button mat-stroked-button color="primary" (click)="goToUpgradeLicense()" class="w-50 me-2">
        Upgrade License
      </button>
      <button mat-stroked-button color="warn" (click)="closeLicensePopup()" class="w-50 ms-2">
        Close
      </button>
    </div>
  </div>
</div>
